<ng-container *ngIf="this.selectedTab === 0">
  <div class="row">
    <div class="col col-1">
    </div>
    <div class="col-2 bold">
      <p>Huidige periode</p>
    </div>
    <div class="col-3 bold">
      <p>Vorige periode</p>
    </div>
  </div>
  <ng-container *ngIf="this.showCustomControls">
    <form [formGroup]="personnelRelatedOtherExpensesFg">
      <div class="row">
        <div class="col col-1">
          <p style="padding: 6px">Overige personeelsgerelateerde kosten</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(1)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    <form [formGroup]="accommodationCostsFg">
      <div class="row">
        <div class="col col-1">
          <p style="padding: 6px">Huisvestingskosten</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(2)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    <form [formGroup]="salesRelatedExpensesFg">
      <div class="row">
        <div class="col col-1">
          <p style="padding: 6px">Verkoop gerelateerde kosten</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(3)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    <form [formGroup]="carAndTransportCostsFg">
      <div class="row">
        <div class="col col-1">
          <p style="padding: 6px">Auto- en transportkosten</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(4)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    <form [formGroup]="officeRelatedExpensesFg">
      <div class="row">
        <div class="col col-1">
          <p style="padding: 6px">Kantoorkosten</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(5)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    <form [formGroup]="generalExpensesFg">
      <div class="row">
        <div class="col col-1">
          <p style="padding: 6px">Algemene kosten</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(6)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    <form [formGroup]="operationalExpensesFg">
      <div class="row">
        <div class="col col-1">
          <p style="padding: 6px">Exploitatiekosten</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(7)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    <form [formGroup]="undefinedOtherExpensesFg">
      <div class="row">
        <div class="col col-1">
          <p style="padding: 6px">Andere kosten</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(8)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    <form [formGroup]="operatingExpensesOtherFg">
      <div class="row">
        <div class="col col-1">
          <p style="padding: 6px"><b>Totaal van overige bedrijfskosten</b></p>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
  </ng-container>
</ng-container>

<ng-container *ngIf="this.selectedTab === 1">
  <form [formGroup]="operatingExpensesOtherDisclosureFg">
    <div class="row">
      <div class="col col-1 pt-3" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over overige bedrijfskosten</p>
      </div>
      <div class="col-2 pt-3">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.operatingExpensesOtherDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(9)">
          {{ this.operatingExpensesOtherDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      @if (isRechtspersoon) {
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            label="In publicatiestukken"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            [disabledControl]="!this.jrDataService.isLegalSizeMediumOrLarger()"
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </div>
  </form>
</ng-container>

<div *ngIf="this.index === 1">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.personnelRelatedOtherExpensesFg"
                                                       [title]="'overige personeelsgerelateerde kosten'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 2">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.accommodationCostsFg"
                                                       [title]="'huisvestingskosten'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 3">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.salesRelatedExpensesFg"
                                                       [title]="'verkoop gerelateerde kosten'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 4">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.carAndTransportCostsFg"
                                                       [title]="'auto- en transportkosten'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 5">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.officeRelatedExpensesFg"
                                                       [title]="'kantoorkosten'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 6">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.generalExpensesFg"
                                                       [title]="'algemene kosten'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 7">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.operationalExpensesFg"
                                                       [title]="'exploitatiekosten'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 8">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.undefinedOtherExpensesFg"
                                                       [title]="'andere kosten'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 9">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.operatingExpensesOtherDisclosureFg"
                                                               [title]="'Informatieverschaffing over overige bedrijfskosten'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
